import { render, staticRenderFns } from "./DigitalHuman.vue?vue&type=template&id=4355326e&scoped=true"
import script from "./DigitalHuman.vue?vue&type=script&lang=ts"
export * from "./DigitalHuman.vue?vue&type=script&lang=ts"
import style0 from "./DigitalHuman.vue?vue&type=style&index=0&id=4355326e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4355326e",
  null
  
)

export default component.exports